import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import {siteConfig} from "../../config/siteConfig";

const ImageTextSection = ({
                              title,
                              content,
                              imageSrc,
                              imageAlt,
                              imageOnRight = false,
                              accentColor = siteConfig.colors.primary
                          }) => {
    return (
        <Box sx={{ py: 8, bgcolor: imageOnRight ? 'white' : siteConfig.colors.lightGray }}>
            <Container maxWidth="lg">
                <Grid
                    container
                    spacing={6}
                    alignItems="center"
                    direction={imageOnRight ? 'row' : 'row-reverse'}
                >
                    {/* Text Content */}
                    <Grid item xs={12} md={6}>
                        <Box>
                            <Typography
                                variant="h3"
                                sx={{
                                    fontWeight: 'bold',
                                    mb: 3,
                                    color: siteConfig.colors.secondary,
                                    position: 'relative',
                                    '&::after': {
                                        content: '""',
                                        position: 'absolute',
                                        bottom: '-12px',
                                        left: 0,
                                        width: '80px',
                                        height: '4px',
                                        bgcolor: accentColor,
                                    }
                                }}
                            >
                                {title}
                            </Typography>

                            {Array.isArray(content) ? (
                                content.map((paragraph, index) => (
                                    <Typography
                                        key={index}
                                        variant="body1"
                                        sx={{
                                            mb: 2,
                                            color: siteConfig.colors.text,
                                            lineHeight: 1.8,
                                            fontSize: '1.1rem'
                                        }}
                                    >
                                        {paragraph}
                                    </Typography>
                                ))
                            ) : (
                                <Typography
                                    variant="body1"
                                    sx={{
                                        mb: 2,
                                        color: siteConfig.colors.text,
                                        lineHeight: 1.8,
                                        fontSize: '1.1rem'
                                    }}
                                >
                                    {content}
                                </Typography>
                            )}
                        </Box>
                    </Grid>

                    {/* Image */}
                    <Grid item xs={12} md={6}>
                        <Box
                            component="img"
                            src={imageSrc}
                            alt={imageAlt}
                            sx={{
                                width: '100%',
                                height: 'auto',
                                borderRadius: 3,
                                boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
                                objectFit: 'cover',
                                maxHeight: '500px',
                                transition: 'transform 0.3s ease',
                                '&:hover': {
                                    transform: 'scale(1.02)',
                                }
                            }}
                        />
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default ImageTextSection;